import Marquee from "react-fast-marquee";

const items = [
  "CHROME 40–42% & HIGHER GRADES",
  "SOURCING",
  "BENEFICIATION",
  "MINERAL LOGISTICS",
  "GLOBAL SUPPLY",
  "MINING PRODIGIES",
];

export const EditorialMarquee = () => (
  <div data-testid="editorial-marquee" className="border-y border-ink/10 py-6 md:py-8 bg-paper overflow-hidden">
    <Marquee speed={28} gradient={false} pauseOnHover>
      {items.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className={`font-display font-semibold text-2xl md:text-4xl tracking-tight px-8 md:px-12 ${i % 2 === 0 ? "text-outline" : "text-ink"}`}>
            {item}
          </span>
          <span className="w-2 h-2 rotate-45 bg-chrome inline-block" />
        </span>
      ))}
    </Marquee>
  </div>
);
